import React from 'react'
import Basics from './../components/Basics'

class Agency extends React.Component {
  render() {
    return (
    	<React.Fragment>
    		<section className="agency center-text container">
    			<div className="row justify-content-around align-items-center container__full">
		    		<div className="col-12 col-sm-10 col-lg-8">
		    			<img src={ process.env.PUBLIC_URL + "/images/coeur.png" } alt="" />
				    	<h2>AGENCE</h2>
				    	<p>
				    		<b>Notre agence est une filiale du groupe Altavia depuis 2013.</b><br/>
				    		Identité de marque, communication commerciale, stratégie digitale...
								Guidés par notre passion du retail et des nouvelles technologies,
								nous mettons un point d’honneur à faire grandir les marques et leur business.
				    	</p>
				    </div>
			    </div>
		    </section>
	    	<Basics />

	    	<section className="consortium center-text container__high">
				<div className="row justify-content-around align-items-center">
					<span className="col-11"><h2>Consortium</h2></span>
					<div className="col-12 col-sm-10 col-lg-8">
						<p><b>Cosmic s’enrichit des compétences du groupe Altavia <br/>et de son Consortium, dont elle est l’interlocuteur privilégié auprès des marques</b></p>
					</div>
					<div className="col-12 col-sm-10 col-lg-6">
						<blockquote>
							<p>Composé des différentes entités du groupe, le Consortium permet d’associer des expertises
							complémentaires afin de créer des équipes projets ad hoc.</p>
							<p>Retail design, digital commerce, veille et analyse des comportements clients, stratégie
							retail... C’est l’union de tous ces savoir-faire qui nous offre la possibilité de répondre,
							de manière précise, à toutes les problématiques de nos clients.</p>
						</blockquote>
					</div>
					<div className="col-12 col-sm-10 col-lg-8">
						<ul>
							<li data-balloon="Retail design" data-balloon-pos="up">
								<img src="/images/logos/altavia-pallas-black.png" alt="Altavia Pallas" />
							</li>
							<li data-balloon="Parcours client" data-balloon-pos="up">
								<img src="/images/logos/altavia-retailtech-black.png" alt="Altavia RetailTech" />
							</li>
							<li data-balloon="Digital commerce" data-balloon-pos="up">
								<img src="/images/logos/insitaction-black.png" alt="Insitaction" />
							</li>
							<li data-balloon="Veille et analyse" data-balloon-pos="up">
								<img src="/images/logos/shoppermind-black.png" alt="Shoppermind" />
							</li>
						</ul>
					</div>
				</div>
	    	</section>
	    	{/*
	    	<section className="key_figures bg--black center-text container-fluid container__high">
	    		<h2>En quelques chiffres</h2>
	    		<div className="row">
	    			<div className="col-md-4">
		    			<h3><span className="figure">40</span> <span>collaborateurs ataraxiques</span></h3>
		    			<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse fermentum, tortor sit amet
		    			faucibus faucibus, odio sem rutrum elit, sit amet ornare lectus dui vel sem. Aenean faucibus id
		    			felis fermentum.</p>
	    			</div>
	    			<div className="col-md-4">
		    			<h3><span className="figure">1,9</span> <span>Million de battements de cœur / jour</span></h3>
		    			<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse fermentum, tortor sit amet
		    			faucibus faucibus, odio sem rutrum elit, sit amet ornare lectus dui vel sem. Aenean faucibus id
		    			felis fermentum.</p>
	    			</div>
	    			<div className="col-md-4">
		    			<h3><span className="figure">10</span> <span>millions de CA en 2017</span></h3>
		    			<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse fermentum, tortor sit amet
		    			faucibus faucibus, odio sem rutrum elit, sit amet ornare lectus dui vel sem. Aenean faucibus id
		    			felis fermentum.</p>
	    			</div>
	    		</div>
	    	</section>
	    */}
	    </React.Fragment>
    )
  }
}

export default Agency



// WEBPACK FOOTER //
// ./src/containers/Agency.jsx